module.exports = __webpack_public_path__ + "img/cattpin2_large.306fbff7.png";